import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Select, Store } from '@ngxs/store';
import {SaveEvaluations,  NetworkMember,  Evaluation,  EvaluationResponse,  EvaluationStateModel, GetEvaluations } from 'huddyapi';

import moment_ from 'moment';
import { Observable, Subscription } from 'rxjs';
import { SavedProvider } from '../settings.component';

import { EditEvaluationDialog } from '../../components/edit-evaluation-dialog/edit-evaluation-dialog.component';


const moment = moment_;

@Component({
  selector: 'evaluations',
  templateUrl: './evaluations.component.html',
  styleUrls: ['./evaluations.component.scss']
})
export class EvaluationsComponent implements OnInit {

  @Input() provider : SavedProvider;
  @Select(state => state.evaluationState) evaluationsState$: Observable<EvaluationStateModel>;
  evaluationsSubscription : Subscription;
  evaluationResponse : EvaluationResponse;



  constructor(
    private store : Store,
    public dialog: MatDialog,
    public matIconRegistry : MatIconRegistry,
    private domSanitizer : DomSanitizer
  ) {


  }

  ngOnInit(): void {
    this.  evaluationsSubscription  = this.evaluationsState$.subscribe((evaluationState: EvaluationStateModel) => {
      console.log(evaluationState);
      if (evaluationState && evaluationState.evaluations  ) {
         this.evaluationResponse = evaluationState.evaluations;
      }
 
    });
    this.store.dispatch(new GetEvaluations(this.provider.id));

   
  }

  getColorFromName(name : string) : string {
    let ret : string = '#DAC7FD';
    if (name) {
      ret = NetworkMember.getColorForName(name);
      if (ret === 'avatarColor0') {
        ret = '#DAC7FD';
      } else if (ret === 'avatarColor1') {
        ret = '#F06D82';
      } else if (ret === 'avatarColor2') {
        ret = '#75C5EC';
      } else if (ret === 'avatarColor3') {
        ret = '#A7C2EF';
      }
    }
    return ret;
  }



  editEvaluation(idx : number) {
    
    const editDialog = this.dialog.open(EditEvaluationDialog, {
      width: '600px',
      data: {
        evaluations: [].concat(this.evaluationResponse.evaluations),
        index: idx,
        providerId : this.provider.id
      }
    });
    
   
  }


  deleteEvaluation(idx: number) {
    if (this.evaluationResponse.familyCount < 1) {
      let evaluations : Evaluation[] = [].concat(this.evaluationResponse.evaluations);
      if (idx > -1) {
        evaluations.splice(idx, 1);
      }
      this.store.dispatch(new SaveEvaluations(evaluations)).subscribe(() => {
       
     } );
    }
  }



}